import { googleAnalytics } from './google-analytics.config';
import * as constants from './constants';
export const APP_CONFIG = {
  googleAnalytics,
  constants,
} as const;
